const SoilSerieModule = {
  namespaced: true,
  state: {
    data: []
  },
  mutations: {
    FETCH: (state, payload) => {
      state.data = payload
    },
    DELETE: (state, payload) => {
      let index = state.data.findIndex(data => data.idx === payload)
      state.data.splice(index, 1)
    },
    UPDATE: (state, payload) => {
      let index = state.data.findIndex(data => data.idx === payload.idx)
      state.data[index] = payload
    },
    INSERT: (state, payload) => {
      state.data.push(payload)
    }
  },
  actions: {
    async fetch({ commit }) {
      try {
        const response = await axios.get(`/soilserie/get`)
        commit('FETCH', response.data)
      } catch (error) {
        throw new Error(error)
      }
    },
    async delete({ commit }, payload) {
      try {
        const response = await axios.delete(`/soilserie/delete/${payload}`)
        if (response.data.message === true) {
          iziToast.info({
            title: 'Deleted!',
            position: 'bottomRight'
          })
        }
        commit('DELETE', payload)
      } catch (error) {
        throw new Error(error)
      }
    },
    async update({ commit, dispatch }, payload) {
      try {
        const response = await axios.put(`/soilserie/update`, payload)
        if (response.data.message === true) {
          iziToast.info({
            title: 'Updated!',
            position: 'bottomRight'
          })
        }
        dispatch('fetch')
        commit('UPDATE', payload)
      } catch (error) {
        throw new Error(error)
      }
    },
    async insert({ commit, dispatch }, payload) {
      try {
        const response = await axios.post(`/soilserie/insert`, payload)
        if (response.data.message === true) {
          iziToast.success({
            title: 'Created!',
            position: 'bottomRight'
          })
          dispatch('fetch')
          commit('INSERT', payload)
        }
      } catch (error) {
        throw new Error(error)
      }
    }
  },
  getters: {
    getAll: state => {
      return state.data
    }
  }
}

export default SoilSerieModule



// WEBPACK FOOTER //
// ./src/store/modules/soils/soil_serie.js